import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-100 text-4xl text-foreground-300">
        <i className="ri-compass-discover-line"></i>
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-primary-500">404</p>
      <h1 className="mt-2 font-heading text-xl font-bold text-foreground-950">
        走丢了，这里没有你要找的页面
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-600">
        可能链接已失效，或内容被调整到了新的分类。回到首页，重新开始高效浏览吧。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/huati"
          className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-background-100 px-6 py-3 text-sm font-semibold whitespace-nowrap text-foreground-800 transition-colors hover:bg-background-200"
        >
          <i className="ri-compass-3-line"></i>
          浏览分类
        </Link>
      </div>
    </section>
  );
}